import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VTabs,{staticClass:"d-print-none",attrs:{"value":_vm.tab,"color":"#00AAFD","background-color":"#192A3E","centered":"","dark":""},on:{"change":_vm.onChange}},_vm._l((_vm.tabs),function(tab_item){return _c(VTab,{key:tab_item.key,attrs:{"href":`#${tab_item.text}`}},[_vm._v("\n\t\t\t"+_vm._s(tab_item.text)+"\n\t\t")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }